import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const path = `m23.94,8c-8.84,0-16,7.16-16,16s7.16,16,16,16,16-7.16,16-16-7.16-16-16-16h0Zm0,29.5c-7.46,
    0-13.5-6.04-13.5-13.5s6.04-13.5,13.5-13.5,13.5,6.04,13.5,13.5c-.01,7.45-6.05,13.49-13.5,
    13.5Zm-14.71-2.23c.44.53.37,1.31-.16,1.75s-1.31.37-1.75-.16h0C.52,28.6,1.29,16.47,9.1,9.14c.5-.47,1.29-.44,
    1.76.05.47.5.44,1.29-.06,1.76h0c-3.61,3.36-5.65,8.07-5.63,13,0,4.13,1.44,8.13,4.06,11.32Zm36.08-11.32c0,
    4.71-1.64,9.27-4.63,12.91-.44.53-1.22.61-1.75.17s-.61-1.22-.17-1.75c2.62-3.19,4.06-7.19,
    4.06-11.32.02-4.93-2.01-9.64-5.62-13-.5-.46-.53-1.25-.07-1.75.23-.25.54-.39.88-.4.33-.03.66.09.89.33,4.08,3.84,6.4,
    9.2,6.41,14.81Zm-21.31,10.05c-1.51,0-2.68-1.16-2.68-2.67s1.16-2.67,2.68-2.67,2.68,1.16,2.68,2.67h0c0,1.39-1.16,
    2.67-2.68,2.67Zm1.98-8.95c0,1.05-.93,1.86-1.98,
    1.86h0c-1.05.12-1.98-.7-1.98-1.74h0c-.12-1.05-.7-8.72-.7-8.72.12-1.39,1.28-2.44,2.68-2.44h0c1.4-.12,2.56,1.05,
    2.68,2.44,0,0-.58,7.56-.7,8.6Z`

/**
 * Stateless function representing an ebs light icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <EbsLightIcon width={48} />
 */
const EbsLightIcon = props => (
    <SvgIcon {...props}>
        <path d={path} />
    </SvgIcon>
)

EbsLightIcon.defaultProps = defaultProps

export { EbsLightIcon }
